var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 138,
    viewBox: "0 0 298 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H294C296.209 0 298 1.79086 298 4V138H0V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H294C296.209 0 298 1.79086 298 4V138H0V4Z",
    fill: "#EAECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.2 41.875H149L140.2 33H113.8C108.96 33 105.044 36.9937 105.044 41.875L105 95.125C105 100.006 108.96 104 113.8 104H184.2C189.04 104 193 100.006 193 95.125V50.75C193 45.8687 189.04 41.875 184.2 41.875ZM184.2 95.125H113.8V50.75H184.2V95.125Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.fb651aef.svg";
export { ForwardRef as ReactComponent };